import { render, staticRenderFns } from "./order-table-group.component.vue?vue&type=template&id=d3c08fc6&"
import script from "./order-table-group.component.vue?vue&type=script&lang=js&"
export * from "./order-table-group.component.vue?vue&type=script&lang=js&"
import style0 from "./order-table-group.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports